import axios from "axios";
import { config } from "../config/config";
import { showToast } from "../components/Toaster/Toaster";
import { authSession, refreshAccessToken } from "./authService";
import { isAccessTokenExpired } from "./helper";

type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

interface AxiosApiCallOptions {
  requireAuth?: boolean;
  extraHeaders?: Record<string, string>;
}

export const axiosApiCall = async (
  endpoint: string,
  method: HttpMethod,
  body?: object,
  options: AxiosApiCallOptions = { requireAuth: true }
) => {

  try {
    const accessToken = await authSession();
    let tokenIsExpired = false;

    if (accessToken && options.requireAuth) {
      tokenIsExpired = isAccessTokenExpired(accessToken);
      console.log("Token Expired:", tokenIsExpired);

      if (tokenIsExpired) {
        await refreshAccessToken();
      }
    }

    const { requireAuth = true, extraHeaders = {} } = options;
    const url = `${config.backendUrl}${endpoint}`;
    const headers = {
      "Content-Type": "application/json",
      ...(requireAuth && { Authorization: `Bearer ${accessToken}` }),
      ...extraHeaders,
    };

    let response;
    switch (method) {
      case "GET":
        response = await axios.get(url, {
          headers,
          ...(body && { params: body }),
        });
        break;
      case "POST":
        response = await axios.post(url, body, { headers });
        break;
      case "PUT":
        response = await axios.put(url, body, { headers });
        break;
      case "PATCH":
        response = await axios.patch(url, body, { headers });
        break;
      case "DELETE":
        response = await axios.delete(url, {
          headers,
          ...(body && { data: body }),
        });
        break;
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }

    return {
      statusCode: response.status,
      body:
        typeof response.data === "string"
          ? JSON.parse(response.data)
          : response.data,
    };
  } catch (err: any) {
    console.error("API Call Error:", {
      message: err.message,
      response: err.response?.data,
      status: err.response?.status,
    });

    if (
      err.response?.data?.message === "Token expired" ||
      err.response?.data?.error === "Token expired"
    ) {
      showToast(
        err.response?.data?.message || err.response?.data?.error,
        "error"
      );
    }

    throw err;
  }
};
